var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPullIcon = function SvgPullIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.168 15C20.6476 15.9114 19.8955 16.669 18.9879 17.1959C18.0803 17.7228 17.0495 18.0004 16 18.0004C14.9505 18.0004 13.9197 17.7228 13.0121 17.1959C12.1045 16.669 11.3524 15.9114 10.832 15H7C6.60218 15 6.22064 15.158 5.93934 15.4393C5.65804 15.7206 5.5 16.1022 5.5 16.5V21C5.5 21.3978 5.65804 21.7794 5.93934 22.0607C6.22064 22.342 6.60218 22.5 7 22.5H25C25.3978 22.5 25.7794 22.342 26.0607 22.0607C26.342 21.7794 26.5 21.3978 26.5 21V16.5C26.5 16.1022 26.342 15.7206 26.0607 15.4393C25.7794 15.158 25.3978 15 25 15H21.168Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12V1.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 9L16 12L19.75 9",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPullIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "pullIcon.8e81d593a36ac0a774b09ef3217baad7.svg";